export enum ClientDocumentRequestStatus {
  Queued = 1,
  Processing = 2,
  Completed = 3,
  Retrying = 4,
  Failed = 5,
}
